


import { value } from "sanctuary";
import { MODIFICATION_URL, TASK_URL } from "../../services/common-urls";
import { JSON_STRING, MHTTPCL } from "../../services/http/http-client";

export const dtTaskService = {

    

    taskList:(external_id,external_table)=>MHTTPCL.post(TASK_URL,{
        section:'base',
        action:'task_list',
        external_table:external_table,
        external_id:external_id
    }),

    taskTabLoad:(external_table)=>MHTTPCL.get(TASK_URL,{
        section:'task_tab',
        action:'task_groups',
        external_table:external_table,
        output:JSON_STRING
    }),

    loadTaskAdd:(external_id,task_group_id)=>MHTTPCL.post(TASK_URL,{
        section:'task_tab',
        action:'load_tasks',
        external_id:external_id,
        task_group_id:task_group_id,
        output:JSON_STRING
    }),

    deleteTask:(task_id)=>MHTTPCL.post(TASK_URL,{
        section:'base',
        action:'delete_task',
        task_id:task_id,
        output:JSON_STRING
    }),

    loadTaskSingle:(task_id)=>MHTTPCL.post(TASK_URL,{
        section:'task_tab',
        action:'load_task',
        task_id:task_id,
        output:JSON_STRING
    }),

    

    addTaskUser:({ external_id,external_table,assigned_users,sent_user,task,due_date,status='open'})=>MHTTPCL.post(TASK_URL,{
        section:'general_task',
        action:'add_task_user',
        external_id:external_id,
        external_table:external_table,
        assigned_users:assigned_users,
        sent_user:sent_user,
        task:task,
        due_date:due_date,
        status:'open',
        output:JSON_STRING
    }),

    updateSingleTaskExtraFiled:({task_id,extra_fields})=>MHTTPCL.post(MODIFICATION_URL,{
        modify_type: 'json',
        table: 'tasks_user',
        kVal: task_id,
        name: 'json_data',
        json_key: 'extra_fields',
        value:extra_fields,
        json_op:'set'
       
    }),

    updateSingleTask:({task_id,task,status,notes,assigned_users})=>MHTTPCL.post(MODIFICATION_URL,{
        modify_type: 'record',
        table: 'tasks_user',
        kVal: task_id,
        task:task,
        status: status,
        notes:notes,
        assigned_users:assigned_users
       
    }),

    loadRelatedProductTasksToReleaseModalData:(release_id)=>MHTTPCL.post(TASK_URL,{
        section:'task_tab',
        action:'load_related_product_tasks_to_release_modal_data',
        release_id:release_id,
        output:JSON_STRING
    }),
    loadRelatedProductTasksToRelease:({release_id,product_ids,task_group_id})=>MHTTPCL.post(TASK_URL,{
        section:'task_tab',
        action:'load_related_product_tasks_to_release',
        release_id:release_id,
        product_ids:product_ids,
        task_group_id:task_group_id,
        output:JSON_STRING
    }),


    



}
